<template>
	<div class="">
		<v-card-title v-if="title" class="d-flex align-center">
			{{ title }}
			<v-icon color="info" @click="load">$reload</v-icon>
		</v-card-title>
		<v-card-title class="ptxxx-0">
			<v-form @submit.prevent="search" class="form-inline">
				<v-row class="">
					<v-col cols="12" class="d-flex flex-wrap align-center">
						<v-text-field outlined class="search-field-name mr-2" dense v-model="query.name" label="名称" hide-details />
						<v-select
							outlined
							class="mr-2"
							dense
							label="状态"
							v-model="query.status"
							:items="refs['STATUSLABEL']"
							item-title="text"
							item-value="value"
							hide-details
							clearable
						></v-select>
						<v-btn color="primary" class="mr-2" @click="search">
							<v-icon>$search</v-icon>
							查询
						</v-btn>
						<v-icon class="mr-2" v-if="queryPairs.length" @click="reset">$close</v-icon>
					</v-col>
				</v-row>
			</v-form>
		</v-card-title>

		<v-data-table-server
			:headers="headers"
			:items="objects"
			@update:options="load"
			:items-length="parseInt(total)"
			:loading="loading"
			:show-select="showSelect"
			:single-select="singleSelect"
			v-model="selected"
			:footer-props="{}"
		>
			<template v-slot:top>
				<slot name="batchActions" v-bind:selected="selected"></slot>
			</template>

			<template v-slot:item.amount="{ item }">
				<span style="color: red" v-if="item.amount > 0">
					{{ item.amount }}
				</span>
				<span style="color: green" v-else>
					{{ item.amount }}
				</span>
			</template>
			<template v-slot:item.shopaccount="{ item }">
				{{ item.shopaccount.name }}
			</template>
			<template v-slot:item.status="{ item }">
				{{ item.status }}
			</template>
			<template v-slot:item.created_at="{ item }">
				{{ $formatTime(item.created_at) }}
			</template>
			<template v-slot:item.from="{ item }">{{ item.from }} => {{ item.to }}</template>

			<template v-slot:item.src_type="{ item }">
				{{ item.src_type }} ({{ item.src_id }})
				<v-btn small outlined color="primary" @click="view(item.src_id)">查看</v-btn>
			</template>
			<template v-slot:item.action="{ item }">
				<slot name="actions" v-bind="{ item }"></slot>
			</template>

			<template v-slot:footer>
				<slot name="batchActions" v-bind="{ selected }"></slot>
			</template>
		</v-data-table-server>
	</div>
</template>

<script>
import { clone, valuesIn, toPairsIn, filter, intersection } from 'lodash-es'

export default {
	components: {},
	props: {
		initQuery: { type: Object, default: null },
		title: { type: String, default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		headers: {
			type: Array,
			default: () => [
				{ title: '#', value: 'id' },
				{ title: '日期', align: 'left', sortable: true, value: 'created_at' },
				{ title: '账户', value: 'shopaccount' },
				{ title: '金额', value: 'amount' },
				{ title: '变动', value: 'from' },
				{ title: '来源', value: 'src_type' },
				// { title: '状态', value: 'status' },
				{ title: '', align: 'left', sortable: false, value: '' }
			]
		}
	},
	data() {
		return {
			query: {}, //查询条件（会变化）
			currentQuery: {}, //当前结果的查询条件 - 用于比较查询条件是否变化
			objects: [],
			total: 0,
			loading: false,
			options: {},
			refs: {},
			selected: [],
			errors: {}
		}
	},
	mounted() {
		if (this.initQuery) {
			this.query = clone(this.initQuery)
		}
		this.load()
	},
	computed: {
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	watch: {
		initQuery: {
			handler(nv, ov) {
				this.query = clone(nv)
				this.load()
			},
			deep: true
		},
		options: {
			handler() {
				this.load()
			},
			deep: true
		}
	},
	methods: {
		search() {
			if (
				this.queryValues.length !== this.currentQueryValues.length ||
				intersection(this.queryValues, this.currentQueryValues).length !== this.queryValues.length
			) {
				//条件变化
				if (this.options.page === 1) {
					//当前如果是第一页，手动触发
					this.load()
				} else {
					this.options.page = 1 //当前不是第一页，修改后通过watcher触发
				}
			} else {
				//条件没变，忽略
			}
		},
		reset() {
			this.query = {}
		},
		view(src_id) {
			if (src_id && src_id.split('|').length > 1) {
				src_id = src_id.split('|')[0]
			}
			this.$router.push(`/order/manage/?sn=${src_id}`)
		},
		load(options = {}) {
			let { sortBy, page, itemsPerPage } = options
			this.loading = true
			let qwp = clone(this.query)
			qwp.pageno = page
			qwp.pagesize = itemsPerPage
			qwp.sortBy = 'id'
			qwp.sortDesc = 'desc'
			if (sortBy && sortBy.length) {
				qwp.sortBy = sortBy[0]
				qwp.sortDesc = sortBy[1] ? 'desc' : 'asc'
			}
			this.currentQuery = clone(this.query)
			qwp['preloads'] = ['ShopAccount']
			this.$api.shop.searchAccountLog(
				qwp,
				(response) => {
					this.objects = response.objects
					this.total = response.total
					this.loading = false
				},
				(error) => {
					this.errors = error.message
					this.loading = false
				}
			)
		}
	}
}
</script>

<style scoped>
.silent td {
	color: rgba(3, 3, 3, 0.5) !important;
}
</style>
